export default "__VITE_ASSET__Dy0uV6jg__"